import React, { useState, useEffect } from "react";
import { AddModal, Dropdown } from "components";

// Компонент редагування існуючої категорії ловушки
const TrapCategoryEditForm = ({
  isOpen,
  onClose,
  allCategories,
  crmCategories,
  onUpdate,
  disabled,
}) => {
  const [categoryId, setCategoryId] = useState(null);
  const [crmCategoryId, setCrmCategoryId] = useState(null);

  // Автоматично підтягуємо поточну CRM категорію при виборі категорії ловушки
  useEffect(() => {
    if (!categoryId) {
      setCrmCategoryId(null);
      return;
    }
    const selectedCat = allCategories.find((c) => c.value === categoryId);
    setCrmCategoryId(selectedCat?.crm_category_id || null);
  }, [categoryId, allCategories]);

  // Очищення форми та закриття модального вікна
  const handleClose = () => {
    setCategoryId(null);
    setCrmCategoryId(null);
    onClose();
  };

  // Функція обробки відправлення форми оновлення
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!categoryId) return;

    onUpdate(categoryId, { crm_category_id: crmCategoryId });
    handleClose();
  };

  return (
    <AddModal isOpen={isOpen} onClose={handleClose} title="Редагування категорії">
      <form onSubmit={handleSubmit}>
        <div className="add-modal-body">
          <div className="form-group">
            <label>Категорія ловушки *</label>
            <Dropdown
              options={allCategories}
              selected={categoryId}
              onChange={setCategoryId}
              mode="autocomplete"
              placeholder="Оберіть категорію для редагування"
            />
          </div>

          <div className="form-group">
            <label>Категорія CRM *</label>
            <Dropdown
              options={crmCategories}
              selected={crmCategoryId}
              onChange={setCrmCategoryId}
              mode="autocomplete"
              placeholder="Оберіть категорію CRM"
            />
          </div>
        </div>

        <div className="add-modal-footer">
          <button type="button" className="btn-cancel" onClick={handleClose}>
            Відміна
          </button>
          <button type="submit" className="btn-save" disabled={disabled || !categoryId}>
            Оновити
          </button>
        </div>
      </form>
    </AddModal>
  );
};

export default TrapCategoryEditForm;
